import React from 'react';
import { createRoot } from 'react-dom/client';

import Layout from './components/layout';
import Spinner from './components/spinner';

import Header from './views/header';
import Hero from './views/hero';
import About from './views/about';
import Services from './views/services';
import Portfolio from './views/portfolio';
import Team from './views/team';
import Contact from './views/contact';

const App = () => (
  <>
    <Layout>
      <Header id='header' />
      <Hero id='home' />
      <About id='about' />
      <Services id='services' />
      <Portfolio id='portfolio' />
      <Team id='team' />
      <Contact id='contact' />
    </Layout>

    <Spinner duration={1000} />
  </>
);

export default App;

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
